const namespaced = true
import _ from 'lodash'
import api from '../../../../api/sap/invoice/supplier_sap.js';

const state = {
    data: null,
    loading: false,
    loadingHistory: false,
    loadingDownload: false,
    loadingDocument: false,
    loadingExpensiveDocument: false,
    loadingInvoicesByDate: false,
    loadingMorePurchasedDocument: false,
    supplierSelect: null,
    whsSelect: { whs_code: "*", whs_name: "Todos" },
    listHistory: [],
    typePrchseItem: 'Factura',
    itemSelect: null,
    purchaseOrder: null,
    purchasesReport: null,
    search: null,
    AgentSelect: [],
    //0 - Complete 1- Partial 2-Incomplete
    filterStatus: 0,
    docNumSelected: 0,
    targetTypeSelected: 0,
    targetEntrySelected: 0,
    flagDocument: false,
    flagDocumentInvoice: false,
    dateInitial: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10), //Se cambio al la fecha por defectoa a hace 3 dias Original: new Date(Date.now()).toISOString().substr(0, 10),
    dateFinal: new Date(Date.now()).toISOString().substr(0, 10),
    totalQuantity: 0,
    totalPrice: 0,
    flagTotal: false,
    firstItemUnitMsr: '',
    docCur: '',
    expensiveArticles: [],
    morePurchasedArticles: [],
    InvoicesByDateAndInvoice: [],
    dataExp: false,
    dataMostPur: false,
    InvoicesMorePur: false,
}

const mutations = {

    MUTATION_SET_DATA(state, data) {
        state.data = data;
    },
    MUTATION_SET_LOADING(state, value) {
        state.loading = value;
    },
    MUTATION_SET_LOADING_HISTORY(state, value) {
        state.loadingHistory = value;
    },
    MUTATION_SET_ARTICULE(state, data) {
        state.listHistory = data;
    },
    MUTATION_SET_TYPE(state, tipo) {
        state.typePrchseItem = tipo;
    },
    MUTATION_SET_KPI(state) {
        state.totalQuantity = _.sumBy(state.data.items, item => parseFloat(item.Quantity));
        state.totalPrice = _.sumBy(state.data.items, item => parseFloat(item.DocTotal));
        state.flagTotal = true;

        if (state.data.items.length > 0) {
            state.firstItemUnitMsr = state.data.items[0].unitMsr;
            state.docCur = state.data.items[0].DOCCUR;
        }
    },
    MUTATION_SET_ITEM_SELECT(state, value) {
        state.itemSelect = value != null ? value : null;
    },
    MUTATION_SET_SEARCH(state, value) {
        state.search = value;
    },
    MUTATION_SET_LOADING_DOCUMENT(state, value) {
        state.loadingDocument = value;
    },
    MUTATION_SET_DATE(state, data) {
        state.dateInitial = data.date1;
        state.dateFinal = data.date2;
    },
    MUTATION_SET_PURCHASE_ORDER(state, value) {
        state.purchaseOrder = value;
    },
    //###############################################################
    //Para articulos mas caros
    SET_EXPENSIVE_ARTICLES(state, data) { //Guarda los articulos mas caros en la variable expensiveArticles
        state.expensiveArticles = data;
    },
    //Para el modulo de carga en el TAB de mas caros
    MUTATION_SET_LOADING_EXPENSIVE(state, value) {
        state.loadingExpensiveDocument = value;
    },

    MUTATION_SET_DATA_EXP(state, data) {
        state.dataExp = data;
    },
    //###############################################################
    //Para articulos mas comprados
    SET_MORE_PURCHASED_ARTICLES(state, data) { //Guarda los articulos mas caros en la variable morePurchasedArticles
        state.morePurchasedArticles = data;
    },

    //Para el modulo de carga en el TAB de mas comprados
    MUTATION_SET_LOADING_MORE_PURCHASED(state, value) {
        state.loadingMorePurchasedDocument = value;
    },

    MUTATION_SET_DATA_MOST_PUR(state, data) {
        state.dataMostPur = data;
    },
    //###############################################################
    SET_MORE_INVOICES_PURCHASED_ARTICLES(state, value) { //Guarda las factuas de los mas comprados por fecha y factura en InvoicesByDateAndInvoice
        state.InvoicesByDateAndInvoice = value;
    },
    
    //Para el modulo de carga en la entana de facturas de mas comprados por fecha y factura
    MUTATION_SET_INVOICES_LOADING_MORE_PURCHASED(state, value) { 
        state.loadingInvoicesByDate = value;
    },
    

    MUTATION_SET_DATA_INVOICES_MOST_PUR(state, value){
        state.InvoicesMorePur = value;
    },

    MUTATION_CLEAN_INVPICES_HISTORY(state, value){
        state.InvoicesByDateAndInvoice = value;
    }



}
const actions = {
    getByWhs(context, data) {
        context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'requisición de compra creada con éxito' }, { root: true });
        context.commit("MUTATION_SET_LOADING", true);
        return new Promise((resolve) => {
            api.getInvoceByitem(
                data.page,
                data.perPage,
                data.date1,
                data.date2,
                data.item,
                data.cardCode
            )
                .then(function (res) {
                    context.commit("MUTATION_SET_DATA", res.data);
                    context.commit('MUTATION_SET_TYPE', res.data.tipo);
                    context.commit("MUTATION_SET_LOADING", false);
                    context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Se obtuvieron un Total: ' + res.data.total }, { root: true });
                    resolve(res.data);
                })
                .catch((e) => {
                    context.commit("MUTATION_SET_LOADING", false);
                    context.dispatch(
                        "notifications/add",
                        {
                            color: "error",
                            visibility: true,
                            timeout: 5000,
                            text: e.messages,
                        },
                        { root: true }
                    );
                });
        });
    },


    clearData(context, data) {
        context.commit("MUTATION_SET_DATA", data);
        context.commit("MUTATION_SET_SUPPLIER_SELECT", "Todos");
        context.commit("MUTATION_SET_WHS_SELECT", {
            whs_code: "*",
            whs_name: "Todos",
        });
    },
    getArticule(context, data) {
        context.commit("MUTATION_SET_LOADING", true);
        context.commit("MUTATION_SET_LOADING_HISTORY", true);
        let tipo = (context.state.typePrchseItem == 'Factura') ? context.state.typePrchseItem : 'orden';
        return new Promise((resolve) => {
            api.byArticule(1, 1000, tipo, data)
                .then(function (res) {
                    context.commit("MUTATION_SET_ARTICULE", res.data.items);
                    context.commit("MUTATION_SET_LOADING", false);
                    context.commit("MUTATION_SET_LOADING_HISTORY", false);
                    resolve(res.data);
                })
                .catch((e) => {
                    context.commit("MUTATION_SET_LOADING", false);
                    context.commit("MUTATION_SET_LOADING_HISTORY", false);
                    context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: e.messages, }, { root: true });
                });
        });
    },
    cleanListHystory(context) {
        context.commit("MUTATION_SET_ARTICULE", []);
    },

    cleanListHystoryDetail(context) {
        context.commit("MUTATION_SET_PURCHASE_ORDER", null);
    },
    getKpis(context) {
        context.commit("MUTATION_SET_KPI");
    },
    setSupplier(context, data) {
        context.commit("MUTATION_SET_SUPPLIER_SELECT", data);
    },
    setWhs(context, data) {
        context.commit("MUTATION_SET_WHS_SELECT", data);
    },
    setItem(context, data) {
        context.commit("MUTATION_SET_ITEM_SELECT", data);
    },
    setSearch(context, data) {
        context.commit("MUTATION_SET_SEARCH", data);
    },

    getDetailInvoce(context, data) {
        return new Promise((resolve) => {
            api.getInvoicesSupplierShow(data).then(function (res) {
                context.commit('MUTATION_SET_PURCHASE_ORDER', res.data);
                context.commit('MUTATION_SET_LOADING_DOCUMENT', false);
                resolve(res.data);
            }).catch((e) => {
                context.commit('MUTATION_SET_LOADING_DOCUMENT', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },

    newDate(context, data) {
        context.commit("MUTATION_SET_DATE", data);
    },

    async getExArticules({ commit }, data) {
        commit('MUTATION_SET_LOADING_EXPENSIVE', true);
        const articles = await api.getByExpensive(data);
        commit('SET_EXPENSIVE_ARTICLES', articles.data.items);
        commit('MUTATION_SET_LOADING_EXPENSIVE', false);
        commit('MUTATION_SET_DATA_EXP', true);
        return articles.data.items;
    },

    async getMorPurchasedArticles({ commit }, data) {
        commit('MUTATION_SET_LOADING_MORE_PURCHASED', true);
        const articles = await api.getByMorePurchased(data);
        commit('SET_MORE_PURCHASED_ARTICLES', articles.data.items);
        commit('MUTATION_SET_LOADING_MORE_PURCHASED', false);
        commit('MUTATION_SET_DATA_MOST_PUR', true);
        return articles.data.items;
    },

    async getMorPurchasedArticlesByInvoices({ commit }, data) {
        commit('MUTATION_SET_INVOICES_LOADING_MORE_PURCHASED', true);
        const articles = await api.getByInvoicesMorePurchased(data);
        commit('SET_MORE_INVOICES_PURCHASED_ARTICLES', articles.data.items);
        commit('MUTATION_SET_INVOICES_LOADING_MORE_PURCHASED', false);
        commit('MUTATION_SET_DATA_INVOICES_MOST_PUR', true);
        return articles.data.items;
    },

    clearHistoryInvoices(context){
        context.commit("MUTATION_CLEAN_INVPICES_HISTORY", null);
    }


}

const getters = {
    getValidate(state) {
        return state.data != null ? state.data.items.length : 0;
    },

    //Obtiene los articulos mas caros
    getExpensiveArticles(state) {
        return state.expensiveArticles;
    },
    //Valida que si hay ya se hizo al menos una ves la query de articulos mas caros
    getValidateExpensive(state) {
        return state.dataExp;
    },
    //Obtiene los articulos mas comprados
    getMorePurchased(state) {
        return state.morePurchasedArticles;
    },
    //Valida que si hay ya se hizo al menos una ves la query de articulos mas comprados
    getValidateMorePurchased(state) {
        return state.dataMostPur;
    },

    getInvoicesByDateAndDate(state) {
        return state.InvoicesByDateAndInvoice;
    },

    getValidateInvoicesExpensiveInvoices(state){
        return state.InvoicesMorePur;
    },


    getPurchasesOrder(state) {
        if (state.data != null) {
            let temp =
                state.supplierSelect == null
                    ? state.data.items
                    : _.filter(state.data.items, [
                        "CardName",
                        state.supplierSelect.CardName,
                    ]);
            if (state.whsSelect.whs_code != "*")
                temp = _.filter(temp, ["WhsCode", state.whsSelect.whs_code]);
            if (state.itemSelect != null)
                temp = _.filter(temp, ["ItemCode", state.itemSelect.ItemCode]);

            return temp;
        } else {
            return [];
        }
    },
    getAntPage(state) {
        return state.data != null ? state.data.antPage : false;
    },
    getNextPage(state) {
        return state.data != null ? state.data.nextPage : false;
    },
    getDataTableExport(state, getter) {
        let transformData = _.map(getter.getPurchasesOrder, (item) => [
            item.DocNum,
            item.DocDate,
            item.ItemCode,
            item.Dscription,
            item.CardName,
            item.WhsCode,
            item.Price,
            item.penultPreComp,
            item.penultFecComp,
        ]);
        return transformData;
    },
    //Transforma los datos de los mas caros en array, para poder descargar en formato excell
    getDataTableExportExpensive(state, getter) {
        let transformData = _.map(getter.getExpensiveArticles, (item) => [
            item.DocNum,
            item.DocDate,
            item.CardName,
            item.CardCode,
            item.Dscription,
            item.ItemCode,
            item.WhsCode,
            item.Quantity,
            item.Price,
            item.TaxCode,
            item.DocTotal,
        ]);
        return transformData;
    },

    //Transforma los datos de los mas comprados en array, para poder descargar en formato excell
    getDataTableExportMorePurchased(state, getter) {
        let transformData = _.map(getter.getMorePurchased, (item) => [
            //item.DocNum,
            //item.DocDate,
            item.ItemCode,
            item.Dscription,
            item.veces_comprados,
            // item.CardName,
            // item.WhsCode,
            // item.Price,
            // item.Price,
            // item.DocDate,
        ]);
        return transformData;
    },

    getDocCur(state) {
        if (state.data == null) {
            return "";
        }
        return state.data.items != null ? state.data.items[0].DocCur : "";
    },


    getDocNum(state) {
        return state.purchaseOrder != null ? state.purchaseOrder[0].DocNum : "";
    },
    getDate(state) {
        return state.purchaseOrder != null
            ? state.purchaseOrder[0].DocDate
            : "";
    },
    getComment(state) {
        return state.purchaseOrder != null
            ? state.purchaseOrder[0].Comments
            : "";
    },
    getDocTotal(state) {
        return state.purchaseOrder != null
            ? state.purchaseOrder[0].DocTotal
            : "";
    },

    getVatSum(state) {
        return state.purchaseOrder != null ? state.purchaseOrder[0].VatSum : "";
    },
    getSubTotal(state) {
        return state.purchaseOrder != null
            ? parseFloat(state.purchaseOrder[0].DocTotal) -
            parseFloat(state.purchaseOrder[0].VatSum)
            : "";
    },
    getReportPurchases(state) {
        return _.groupBy(
            _.orderBy(state.purchasesReport, ["DocEntry"], ["desc"]),
            "DocEntry"
        );
    },


}
export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}